import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCloudOrgScoreService } from '../../services';
import '../../styles/dashboardV2.scss';

const CloudOrgScoreDetails = () => {
    const navigate = useNavigate();
    const [scoreData, setScoreData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDetails = async () => {
            let query = `?all_details=true`
            try {
                const response = await getCloudOrgScoreService(query);
                const data = response?.statusCode?.response_data?.data || null;
                setScoreData(data);
            } catch (error) {
                console.error("Error fetching cloud org score details:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchDetails();
    }, []);

    if (loading) {
        return (
            <div className="cloud-details-loading">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    const breakdown = scoreData?.breakdown || [];

    return (
        <div className="cloud-score-details">
            <div className="cloud-score-details__header">
                <button className="btn-back" onClick={() => navigate(-1)}>
                    ← Back
                </button>
                <div className="cloud-score-details__title-wrap">
                    <h2 className="cloud-score-details__title">Cloud Security Breakdown</h2>
                    <p className="cloud-score-details__subtitle">Detailed compliance overview across all cloud environments</p>
                </div>
            </div>

            <div className="score-breakdown-grid">
                {breakdown.map((item, idx) => {
                    const passCount = item.pass_count || 0;
                    const totalCount = item.total_count || 0;
                    const score = totalCount > 0 ? Math.round((passCount / totalCount) * 100) : 0;

                    return (
                        <div key={idx} className="breakdown-card" onClick={() => navigate(`/cloud-service-details/${item.service_name}`)} style={{ cursor: 'pointer' }}>
                            <div className="breakdown-card__header">
                                <div className="breakdown-card__icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                                    </svg>
                                </div>
                                <div className="breakdown-card__score-ratio">
                                    <span className={score === 100 ? 'text-success' : 'text-danger'}>{passCount}/{totalCount}</span>

                                </div>
                            </div>
                            <div className="breakdown-card__body">
                                <h4 className="breakdown-card__name text-truncate" title={item.service}>
                                    {item.service_name}
                                </h4>
                                <div className="breakdown-card__status">
                                    <span className="dot active"></span>
                                    Active
                                </div>
                                <div className={`breakdown-card__indicator ${score < 50 ? 'bg-danger' : score < 100 ? 'bg-warning' : 'bg-success'}`}></div>
                            </div>
                        </div>
                    );
                })}
                {breakdown.length === 0 && (
                    <div className="col-12 text-center py-5">
                        <p className="text-muted">No breakdown data available for the latest scan.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CloudOrgScoreDetails;
